import React from "react";

const Summary = ({ fromDate, toDate }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const formattedFromDate = formatDate(fromDate);
  const formattedToDate = formatDate(toDate);
  const currentUrl = window.location.href;
  const Test = currentUrl.includes("leagues_test"); 

  return (
    <section>
      <div className="text-[white] text-center">
      <h3 className="m-5 text-2xl font-bold text-slate-600">
        League Tables - Updated Now For Jan - {formattedToDate} {Test && "(First Draft) in the Test page."}
      </h3>
        <p className="m-4 leading-5 text-slate-700 text-sm md:text-base md:mx-24">
          The Venture Intelligence League Tables, the first such initiative
          exclusively tracking transactions involving India-based companies, are
          based on value of PE and M&A transactions advised by I-Bank and
          Legal Advisory firms during the calendar year. The League Tables are
          compiled based on transactions submitted by the advisory firms and
          filtered using Venture Intelligence definitions
        </p>
        <div className="px-2  lg:px-4 group rounded-md">
          <a
            href="https://www.ventureintelligence.info/account/login/"
            className="inline-block px-4 py-2 bg-[#bc8b20] text-white rounded-md hover:bg-[#d6b15f] transition-colors duration-300 text-sm font-medium"
          >
            Deal Submission
          </a>
        </div>
      </div>
    </section>
  );
};

export default Summary;
